import { useState, useEffect } from 'react';

/**
 * Returns a Date that auto-updates every `intervalMs` milliseconds.
 * Only the component tree consuming `now` re-renders.
 */
export function useNowTick(intervalMs = 60_000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
